import { createApp, h } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import clickout from './directives/clickoutside';
import { axiosHelper } from './helpers/axios';
import middlewareHelper from './helpers/auth';
import i18n from './i18n';
import GoogleIdentity from 'vue-google-identity';
import emitterHelper from './helpers/emitter.js';
import { createGtag } from 'vue-gtag';
import vSelect from 'vue-select';
import crossIcon from '@/assets/icons/cross2.svg';

const app = createApp(App);

app.use(GoogleIdentity, {
  clientId: import.meta.env.VITE_GOOGLE_ID,
  authorizationConfiguration: {
    scope:
      'email profile openid https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
  },
});

app.directive('clickout', clickout);
app.use(axiosHelper, { apiUrl: import.meta.env.VITE_API_URL, store });
app.use(router);
app.use(store);
app.use(middlewareHelper, { store, router });
app.use(i18n);
app.use(emitterHelper);

const gtag = createGtag({
  tagId: import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID,
});
app.use(gtag);

vSelect.props.components.default = () => ({
  Deselect: {
    render: () => h(crossIcon, { style: 'height: 6px; width: 6px;' }),
  },
});

// eslint-disable-next-line vue/component-definition-name-casing
app.component('v-select', vSelect);

app.mount('#app');

app.use(() => {
  Object.defineProperty(app.config.globalProperties, '$addTemplateCss', {
    get: () => template => {
      const cssId = template.name;
      if (template.cssLink && !document.getElementById(cssId)) {
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = template.cssLink;
        link.media = 'all';
        head.appendChild(link);
      }
    },
  });
});
